// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-date-picker-container-bg-color: var(--ds-color-grey-indigo-80);
    --ds-date-picker-container-box-shadow-color: var(--ds-color-grey-90);
    --ds-date-picker-container-border-color: var(--ds-color-grey-indigo-40);
    --ds-calendar-header-text-color: var(--ds-font-color-accent);
    --ds-calendar-header-font-size: var(--ds-text-small);
    --ds-calendar-header-border-color: var(--ds-color-grey-40);
    --ds-calendar-weekday-text-color: var(--ds-color-grey-indigo-10);
    --ds-week-days-header-border-color: var(--ds-color-grey-indigo-50);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
